export default "__VITE_ASSET__izo9ny0k__"